webpackJsonp([196612995704195],{

/***/ 380:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var statusFor = function statusFor(configuration) {
	  var states = configuration || [];
	  if (states.indexOf('open') > -1) return { label: 'open', color: '#b8352f', detail: 'Fail fast while the dependency recovers.' };
	  if (states.indexOf('halfOpen') > -1) return { label: 'half-open', color: '#c9821f', detail: 'Allow one probe request.' };
	  return { label: 'closed', color: '#1f7a4d', detail: 'Requests flow normally.' };
	};
	
	var CircuitBreakerPanel = function CircuitBreakerPanel(_ref) {
	  var configuration = _ref.configuration,
	      datamodel = _ref.datamodel,
	      log = _ref.log,
	      onEvent = _ref.onEvent,
	      onReset = _ref.onReset;
	
	  var status = statusFor(configuration);
	  var failureCount = datamodel && typeof datamodel.failureCount !== 'undefined' ? datamodel.failureCount : 0;
	  var failureThreshold = datamodel && datamodel.failureThreshold ? datamodel.failureThreshold : 3;
	  var lastResult = datamodel && datamodel.lastResult ? datamodel.lastResult : 'none';
	
	  return _react2.default.createElement(
	    'div',
	    { style: { height: '100%', padding: '1rem', background: '#f7f7f7', overflow: 'auto' } },
	    _react2.default.createElement(
	      'div',
	      { style: { background: status.color, color: '#fff', padding: '1rem', marginBottom: '1rem' } },
	      _react2.default.createElement(
	        'div',
	        { style: { textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: '0.08em' } },
	        'Circuit state'
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: { fontSize: '2rem', lineHeight: '2.4rem' } },
	        status.label
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        status.detail
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem', marginBottom: '1rem' } },
	      _react2.default.createElement(
	        'div',
	        { style: { background: '#fff', border: '1px solid #ddd', padding: '0.75rem' } },
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Failures'
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          failureCount,
	          ' / ',
	          failureThreshold
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: { background: '#fff', border: '1px solid #ddd', padding: '0.75rem' } },
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Last result'
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          lastResult
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { marginBottom: '1rem' } },
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-success', style: { marginRight: '0.5rem', marginBottom: '0.5rem' }, onClick: function onClick() {
	            return onEvent('call.success');
	          } },
	        'Successful call'
	      ),
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-danger', style: { marginRight: '0.5rem', marginBottom: '0.5rem' }, onClick: function onClick() {
	            return onEvent('call.failure');
	          } },
	        'Failed call'
	      ),
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-secondary', style: { marginRight: '0.5rem', marginBottom: '0.5rem' }, onClick: function onClick() {
	            return onEvent('cooldown.elapsed');
	          } },
	        'Cooldown elapsed'
	      ),
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-light', style: { marginBottom: '0.5rem' }, onClick: onReset },
	        'Reset'
	      )
	    ),
	    _react2.default.createElement(
	      'strong',
	      null,
	      'Trace'
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { marginTop: '0.5rem', fontFamily: 'monospace', fontSize: '0.85rem' } },
	      (log || []).map(function (entry, index) {
	        return _react2.default.createElement(
	          'div',
	          { key: entry + '-' + index, style: { padding: '0.3rem 0', borderTop: index ? '1px solid #e2e2e2' : 0 } },
	          entry
	        );
	      })
	    )
	  );
	};
	
	exports.default = CircuitBreakerPanel;
	module.exports = exports['default'];

/***/ }),

/***/ 880:
/***/ (function(module, exports) {

	module.exports = "<scxml datamodel=\"ecmascript\"\n       initial=\"closed\"\n       name=\"CircuitBreaker\"\n       version=\"1.0\"\n       xmlns=\"http://www.w3.org/2005/07/scxml\">\n  <datamodel>\n    <data id=\"failureCount\" expr=\"0\"/>\n    <data id=\"failureThreshold\" expr=\"3\"/>\n    <data id=\"lastResult\" expr=\"'none'\"/>\n  </datamodel>\n\n  <state id=\"closed\">\n    <onentry>\n      <send event=\"trace\">\n        <content expr=\"'Circuit is closed: requests flow to the dependency.'\"/>\n      </send>\n    </onentry>\n    <transition event=\"call.success\">\n      <assign location=\"failureCount\" expr=\"0\"/>\n      <assign location=\"lastResult\" expr=\"'success'\"/>\n      <send event=\"trace\">\n        <content expr=\"'Call succeeded; failure count reset.'\"/>\n      </send>\n    </transition>\n    <transition event=\"call.failure\" cond=\"failureCount + 1 &gt;= failureThreshold\" target=\"open\">\n      <assign location=\"failureCount\" expr=\"failureCount + 1\"/>\n      <assign location=\"lastResult\" expr=\"'failure'\"/>\n      <send event=\"trace\">\n        <content expr=\"'Failure threshold reached; opening circuit.'\"/>\n      </send>\n    </transition>\n    <transition event=\"call.failure\">\n      <assign location=\"failureCount\" expr=\"failureCount + 1\"/>\n      <assign location=\"lastResult\" expr=\"'failure'\"/>\n      <send event=\"trace\">\n        <content expr=\"'Call failed; failure count increased.'\"/>\n      </send>\n    </transition>\n  </state>\n\n  <state id=\"open\">\n    <onentry>\n      <send event=\"trace\">\n        <content expr=\"'Circuit is open: calls fail fast.'\"/>\n      </send>\n      <send event=\"cooldown.elapsed\" delay=\"3000ms\" id=\"cooldown\"/>\n    </onentry>\n    <onexit>\n      <cancel sendid=\"cooldown\"/>\n    </onexit>\n    <transition event=\"cooldown.elapsed\" target=\"halfOpen\"/>\n    <transition event=\"reset\" target=\"closed\">\n      <assign location=\"failureCount\" expr=\"0\"/>\n      <assign location=\"lastResult\" expr=\"'manual reset'\"/>\n    </transition>\n  </state>\n\n  <state id=\"halfOpen\">\n    <onentry>\n      <send event=\"trace\">\n        <content expr=\"'Circuit is half-open: allow one probe request.'\"/>\n      </send>\n    </onentry>\n    <transition event=\"call.success\" target=\"closed\">\n      <assign location=\"failureCount\" expr=\"0\"/>\n      <assign location=\"lastResult\" expr=\"'probe success'\"/>\n      <send event=\"trace\">\n        <content expr=\"'Probe succeeded; closing circuit.'\"/>\n      </send>\n    </transition>\n    <transition event=\"call.failure\" target=\"open\">\n      <assign location=\"failureCount\" expr=\"failureThreshold\"/>\n      <assign location=\"lastResult\" expr=\"'probe failure'\"/>\n      <send event=\"trace\">\n        <content expr=\"'Probe failed; reopening circuit.'\"/>\n      </send>\n    </transition>\n    <transition event=\"reset\" target=\"closed\">\n      <assign location=\"failureCount\" expr=\"0\"/>\n      <assign location=\"lastResult\" expr=\"'manual reset'\"/>\n    </transition>\n  </state>\n</scxml>\n"

/***/ }),

/***/ 381:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.circuitBreakerScxml = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _scxml = __webpack_require__(28);
	
	var _scxml2 = _interopRequireDefault(_scxml);
	
	var _schviz = __webpack_require__(13);
	
	var _schviz2 = _interopRequireDefault(_schviz);
	
	var _circuitBreakerPanel = __webpack_require__(380);
	
	var _circuitBreakerPanel2 = _interopRequireDefault(_circuitBreakerPanel);
	
	var _circuitBreaker = __webpack_require__(880);
	
	var _circuitBreaker2 = _interopRequireDefault(_circuitBreaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	exports.circuitBreakerScxml = _circuitBreaker2.default;
	
	var CircuitBreakerExample = function (_React$Component) {
	  _inherits(CircuitBreakerExample, _React$Component);
	
	  function CircuitBreakerExample(props) {
	    _classCallCheck(this, CircuitBreakerExample);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.timeouts = {};
	    _this.state = { log: [] };
	    return _this;
	  }
	
	  CircuitBreakerExample.prototype.componentDidMount = function componentDidMount() {
	    this.start();
	  };
	
	  CircuitBreakerExample.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.cancelAll();
	  };
	
	  CircuitBreakerExample.prototype.start = function start() {
	    var _this2 = this;
	
	    this.cancelAll();
	    this.setState({ log: [] });
	
	    _scxml2.default.documentStringToModel(null, _circuitBreaker2.default, function (err, model) {
	      if (err) throw err;
	      model.prepare(function (err, modelFactory) {
	        if (err) throw err;
	
	        _this2.sc = new _scxml2.default.scion.Statechart(modelFactory, {
	          customSend: _this2.customSend.bind(_this2),
	          customCancel: _this2.customCancel.bind(_this2)
	        });
	
	        var transitionsEnabled = void 0;
	        _this2.sc.on('onBigStepBegin', function () {
	          transitionsEnabled = new Map();
	        });
	        _this2.sc.on('onBigStepEnd', function () {
	          var _sc$getSnapshot = _this2.sc.getSnapshot(),
	              _ = _sc$getSnapshot[0],
	              history = _sc$getSnapshot[1],
	              isInFinalState = _sc$getSnapshot[2],
	              datamodel = _sc$getSnapshot[3];
	
	          _this2.setState({
	            datamodel: datamodel,
	            configuration: _this2.sc.getFullConfiguration(),
	            transitionsEnabled: transitionsEnabled
	          });
	        });
	        _this2.sc.on('onTransition', function (transitionSourceId, targetIds, transitionIndex) {
	          if (transitionsEnabled.has(transitionSourceId)) {
	            transitionsEnabled.get(transitionSourceId).add(transitionIndex);
	          } else {
	            transitionsEnabled.set(transitionSourceId, new Set([transitionIndex]));
	          }
	        });
	        _this2.sc.start();
	      });
	    });
	  };
	
	  CircuitBreakerExample.prototype.customSend = function customSend(event, options) {
	    var _this3 = this;
	
	    var send = function send() {
	      if (event.name === 'trace') {
	        _this3.appendLog(event.data);
	      } else {
	        _this3.sc.gen(event);
	      }
	    };
	
	    if (options && options.delay) {
	      this.timeouts[event.sendid] = setTimeout(send, options.delay);
	    } else {
	      send();
	    }
	  };
	
	  CircuitBreakerExample.prototype.customCancel = function customCancel(sendid) {
	    clearTimeout(this.timeouts[sendid]);
	    delete this.timeouts[sendid];
	  };
	
	  CircuitBreakerExample.prototype.cancelAll = function cancelAll() {
	    var _this4 = this;
	
	    Object.keys(this.timeouts).forEach(function (sendid) {
	      return _this4.customCancel(sendid);
	    });
	  };
	
	  CircuitBreakerExample.prototype.appendLog = function appendLog(entry) {
	    if (!entry) return;
	    this.setState(function (_ref) {
	      var log = _ref.log;
	      return { log: log.concat(entry).slice(-12) };
	    });
	  };
	
	  CircuitBreakerExample.prototype.send = function send(event) {
	    if (this.sc) this.sc.gen(event);
	  };
	
	  CircuitBreakerExample.prototype.reset = function reset() {
	    if (this.sc) this.sc.gen('reset');
	  };
	
	  CircuitBreakerExample.prototype.render = function render() {
	    var _this5 = this;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'row', style: { minHeight: '560px' } },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-8', style: { marginBottom: '1rem' } },
	        _react2.default.createElement(
	          'div',
	          { style: { height: '560px', width: '100%', position: 'relative', border: '1px solid #eee' } },
	          _react2.default.createElement(_schviz2.default, {
	            scxmlDocumentString: _circuitBreaker2.default,
	            disableAnimation: true,
	            disableZoom: true,
	            configuration: this.state && this.state.configuration,
	            disableZoomAnimation: true,
	            transitionsEnabled: this.state && this.state.transitionsEnabled,
	            expandAllStatesByDefault: true,
	            layoutOptions: _schviz2.default.layouts.auto,
	            id: 'circuit-breaker'
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-4', style: { marginBottom: '1rem' } },
	        _react2.default.createElement(
	          'div',
	          { style: { height: '560px', border: '1px solid #eee' } },
	          _react2.default.createElement(_circuitBreakerPanel2.default, {
	            configuration: this.state.configuration,
	            datamodel: this.state.datamodel,
	            log: this.state.log,
	            onEvent: function onEvent(event) {
	              return _this5.send(event);
	            },
	            onReset: function onReset() {
	              return _this5.reset();
	            }
	          })
	        )
	      )
	    );
	  };
	
	  return CircuitBreakerExample;
	}(_react2.default.Component);
	
	exports.default = CircuitBreakerExample;

/***/ }),

/***/ 429:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var React = _interopRequireWildcard(_react);
	
	var _prismjs = __webpack_require__(38);
	
	var _prismjs2 = _interopRequireDefault(_prismjs);
	
	var _reactPrism = __webpack_require__(22);
	
	var _reactPrism2 = _interopRequireDefault(_reactPrism);
	
	var _TutorialPageWrapper = __webpack_require__(18);
	
	var _TutorialPageWrapper2 = _interopRequireDefault(_TutorialPageWrapper);
	
	var _circuitBreakerExample = __webpack_require__(381);
	
	var _circuitBreakerExample2 = _interopRequireDefault(_circuitBreakerExample);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var CircuitBreaker = function CircuitBreaker(_ref) {
	  var sectionName = _ref.sectionName,
	      by = _ref.by;
	  return React.createElement(
	    'div',
	    null,
	    React.createElement(
	      'h1',
	      null,
	      sectionName
	    ),
	    React.createElement(
	      'h6',
	      null,
	      by
	    ),
	    React.createElement(
	      'p',
	      null,
	      'This example models the circuit breaker resilience pattern. The statechart keeps calls flowing while closed, fails fast while open, and uses a half-open probe to decide whether the dependency has recovered.'
	    ),
	    React.createElement(_circuitBreakerExample2.default, null),
	    React.createElement(
	      'h2',
	      null,
	      'SCXML source'
	    ),
	    React.createElement(
	      _reactPrism2.default,
	      { component: 'pre', className: 'language-xml' },
	      _circuitBreakerExample.circuitBreakerScxml
	    )
	  );
	};
	
	var WrappedCircuitBreaker = function WrappedCircuitBreaker(_ref2) {
	  var location = _ref2.location;
	  return React.createElement(_TutorialPageWrapper2.default, { Component: CircuitBreaker, pathname: location.pathname });
	};
	
	exports.default = WrappedCircuitBreaker;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-tutorials-examples-circuit-breaker-js-03df41543d1976a60c5c.js